"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementSelector = exports.getNextPendingStep = exports.getScrollOptionsByStepType = exports.getCustomOffsetByStepSubtype = exports.makeGuidableText = exports.getGuidableStepsFromTokens = void 0;
var lodash_1 = require("lodash");
var SelectorUtils_1 = require("@CommonFrontend/Utils/SelectorUtils");
var getGuidableStepsFromTokens = function (tokens) {
    var inlineWidgetTypes = ["signature", "initials"];
    return tokens
        .filter(function (token) { var _a; return token.type === "block" && inlineWidgetTypes.includes(token.subType) && !!((_a = token["widgetId"]) === null || _a === void 0 ? void 0 : _a.id); })
        .map(function (token) { return ({
        id: token["widgetId"].id,
        type: "widget",
        subType: token.subType,
    }); });
};
exports.getGuidableStepsFromTokens = getGuidableStepsFromTokens;
var makeGuidableText = function (subType) {
    switch (subType) {
        case "signature": {
            return "Sign";
        }
        case "initials": {
            return "Initial";
        }
        case "accept-form": {
            return "Fill";
        }
        default: {
            return "Action required";
        }
    }
};
exports.makeGuidableText = makeGuidableText;
var getCustomOffsetByStepSubtype = function (subType) {
    var _a, _b;
    switch (subType) {
        case "signature":
        case "initials": {
            var widgetHeight = (_b = (_a = document.querySelector((0, SelectorUtils_1.toSelector)("signature-slot-empty-button"))) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
            var margin = 12;
            return widgetHeight / 2 + margin;
        }
        case "accept-form": {
            return 0;
        }
        default: {
            return 0;
        }
    }
};
exports.getCustomOffsetByStepSubtype = getCustomOffsetByStepSubtype;
var getScrollOptionsByStepType = function (type) {
    switch (type) {
        case "signature":
        case "initials": {
            return { behavior: "smooth", block: "end", scrollMode: "always" };
        }
        case "accept-flow": {
            return { behavior: "smooth", block: "start", scrollMode: "always" };
        }
        default: {
            return { behavior: "smooth", block: "center", scrollMode: "if-needed" };
        }
    }
};
exports.getScrollOptionsByStepType = getScrollOptionsByStepType;
var getNextPendingStep = function (steps, startFrom) {
    var _a, _b, _c, _d;
    var hasPending = steps.some(function (step) { return step.completed === false; });
    if (!hasPending) {
        return null;
    }
    var startIndex = 0;
    if (startFrom) {
        var idx = steps.findIndex(function (step) { return step.id === startFrom; });
        startIndex = idx > -1 ? idx : 0;
    }
    var predicate = function (step) {
        return step.completed === false;
    };
    var nextIndex = (0, lodash_1.findIndex)(steps, predicate, startIndex);
    if (nextIndex !== -1) {
        return (_b = (_a = steps[nextIndex]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    }
    var loopedNextIndex = (0, lodash_1.findIndex)(steps.slice(0, startIndex), predicate);
    return (_d = (_c = steps[loopedNextIndex]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null;
};
exports.getNextPendingStep = getNextPendingStep;
var getElementSelector = function (type, id) {
    if (type === "widget") {
        return "[data-widget-id=\"".concat(id, "\"]");
    }
    return "[data-qwilr-component=\"".concat(id, "\"]");
};
exports.getElementSelector = getElementSelector;
